import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {FilterRecordButton} from "../buttons/FilterRecordButton.tsx";
import {MigrateRecordButton} from "../buttons/MigrateRecordButton.tsx";
import {CleanupMigratedButton} from "../buttons/CleanupMigratedButton.tsx";
import {ProvisionPipelineButton} from "../buttons/ProvisionPipelineButton.tsx";
import config from "../config";


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>, <FilterRecordButton key='filter'/>];

    if (allowedActions.includes('DeletePipeline')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('MigrateCodePipeline')) {
        tools.push(<MigrateRecordButton key='migrate'/>);
    }

    if (allowedActions.includes('CleanupMigratedPipeline')) {
        tools.push(<CleanupMigratedButton key='cleanup'/>);
    }

    if (allowedActions.includes('ProvisionPipeline')) {
        tools.push(<ProvisionPipelineButton key='provision'/>);
    }

    if (allowedActions.includes('CreatePipeline')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
